import React from "react";
import './index.css'
import ActionInput from "../../../components/common/actioninput/ActionInputField";
import ExcelLogo from '../../../assets/272697_excel_icon.png'
import ButtonComponent from "../../../components/common/button/Button";

const FileOverivew = ({ fileName, fileOverviewDetails }) => {
    const handleDownloadErrorFile = () => {
        // const csvContent = `data:text/csv;charset=utf-8,${fileOverviewDetails.data}\n`;
        // const encodedUri = encodeURI(csvContent);
        // const link = document.createElement('a');
        // link.setAttribute('href', encodedUri);
        // link.setAttribute('download', `${fileName.replace(/\s*\(\d+\)|\.csv/g, "")}Errors.csv`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);


        const blob = new Blob([fileOverviewDetails?.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${fileName.replace(/\s*\(\d+\)|\.csv/g, "")}Errors.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return (
        <>
            <div className="materials">
                <div className="flex-items-row">
                    <p className="line-items">No of line items newly created</p>
                    <ActionInput value={fileOverviewDetails?.headers["x-newcount"] || 0} disabled={true}
                        props={{ height: "35px", maxWidth: "70px", }}
                    />
                </div>
                <div className="flex-items-row">
                    <p className="line-items">No of line items updated</p>
                    <ActionInput value={fileOverviewDetails?.headers["x-updatecount"] || 0} disabled={true}
                        props={{ height: "35px", maxWidth: "70px", }}
                    />
                </div>
                <div className="flex-items-row">
                    <p className="line-items">No of line items with error</p>
                    <ActionInput value={fileOverviewDetails?.headers["x-errorcount"] || 0} disabled={true}
                        props={{ height: "35px", maxWidth: "70px" }}
                    />
                </div>
                {(fileOverviewDetails?.headers["x-errorcount"] !== "0") ?
                    <div>
                        <span className="viewDetailsErrorText">Click here to view the details for the error line items</span>
                        <div className="flex-items-row error-line-items-container" onClick={handleDownloadErrorFile}>
                            <img style={{ paddingTop: "10px" }} src={ExcelLogo} alt='logo' width={20} height={20} />
                            <span className="font-size" style={{ paddingTop: "10px" }}>{fileName}</span>
                        </div>
                    </div>
                    :
                    <></>
                }

            </div>

        </>
    )
}


const FileOverivewFooter = (props) => {
    return (
        <div className="footer-button-wrapper">
            <ButtonComponent
                type="secondary"
                maxWidth="180px"
                label="OK"
                onClick={props?.close}
            />
        </div>
    )
}
export { FileOverivew, FileOverivewFooter }